import React, { useState } from "react";
import "../styles/CreateInvoice.css";
import { uploadAmazonExcel, uploadMeeshoExcel,uploadFlipKartExcel, createSalesInvoice, recreateSalesInvoice } from "../api";

const CreateInvoice = () => {
  const [amazonFile, setAmazonFile] = useState(null);
  const [meeshoFile, setMeeshoFile] = useState(null);
  const [flipkartFile, setflipkartFile] = useState(null);

  // Separate states for Amazon and Meesho upload status
  const [amazonStatus, setAmazonStatus] = useState("");
  const [meeshoStatus, setMeeshoStatus] = useState("");
  const [flipkartStatus, setFlipkartStatus] = useState("");

  // States for invoice creation
  const [invoiceStatus, setInvoiceStatus] = useState("");
  const [successfulOrders, setSuccessfulOrders] = useState([]);
  const [failedOrders, setFailedOrders] = useState([]);

  const handleFileChange = (e, type) => {
    if (type === "amazon") {
      setAmazonFile(e.target.files[0]);
    } else if (type === "meesho") {
      setMeeshoFile(e.target.files[0]);
    }
    else
    if (type === "flipkart") {
      setflipkartFile(e.target.files[0]);
    }
  };

  const handleUpload = async (uploadFunction, fileType) => {
   // const file = fileType === "amazon" ? amazonFile : meeshoFile;
   let file;
    if (fileType === "amazon") {
      file = amazonFile;
    } else if (fileType === "meesho") {
      file = meeshoFile;
    } else if (fileType === "flipkart") {
      file = flipkartFile;
    }

    if (!file) {
      if (fileType === "amazon") {
        setAmazonStatus({ message: "Please select an Amazon file first!", type: "error" });
      } else if (fileType === "meesho") {
        setMeeshoStatus({ message: "Please select a Meesho file first!", type: "error" });
      }
      else if (fileType === "flipkart") {
        setFlipkartStatus({ message: "Please select a flipkart file first!", type: "error" });
      }
      return;
    }

    try {
      // if (fileType === "amazon") {
      //   setAmazonStatus({ message: "Uploading Amazon file...", type: "info" });
      // } else if (fileType === "meesho") {
      //   setMeeshoStatus({ message: "Uploading Meesho file...", type: "info" });
      // }

      const response = await uploadFunction(file);

      if (response && response.success) {
        const successMessage = response.message || `${fileType} file uploaded successfully!`;
        if (fileType === "amazon") {
          setAmazonStatus({ message: successMessage, type: "success" });
        } else if (fileType === "meesho") {
          setMeeshoStatus({ message: successMessage, type: "success" });
        }
        else
        if (fileType === "flipkart") {
          setFlipkartStatus({ message: successMessage, type: "success" });
        }
      } else {
        const errorMessage = response.message || `An error occurred while uploading the ${fileType} file.`;
        if (fileType === "amazon") {
          setAmazonStatus({ message: errorMessage, type: "error" });
        } else if (fileType === "meesho") {
          setMeeshoStatus({ message: errorMessage, type: "error" });
        }
        else if (fileType === "flipkart") {
          setFlipkartStatus({ message: errorMessage, type: "error" });
        }
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error.message || "Unknown error occurred";
      if (fileType === "amazon") {
        setAmazonStatus({ message: `${errorMessage}`, type: "error" });
      } else if (fileType === "meesho") {
        setMeeshoStatus({ message: `${errorMessage}`, type: "error" });
      } else
      if(fileType === "flipkart")
      {
        setFlipkartStatus({message :`${errorMessage}`,type:"error"});
      }
      console.error(error);
    }
  };

  const handleCreateInvoice = async () => {
    try {
      setInvoiceStatus({ message: "Generating invoices...", type: "info" });
      const response = await createSalesInvoice();

      console.log("API Response:", response); // Debugging the response structure

      // Filter successful and failed orders
      const successfulOrders = response.filter((item) => item.status === "Success");
      const failedOrders = response.filter((item) => item.status === "Failed");

      // Determine the status message
      if (successfulOrders.length > 0 && failedOrders.length === 0) {
        setInvoiceStatus({ message: "All invoices created successfully!", type: "success" });
      } else if (successfulOrders.length > 0 && failedOrders.length > 0) {
        setInvoiceStatus({
          message: `${successfulOrders.length} invoices created successfully. ${failedOrders.length} failed.`,
          type: "warning",
        });
      } else {
        setInvoiceStatus({ message: "Failed to create invoices. Please check the details.", type: "error" });
      }

      // Store successful and failed orders for display
      setSuccessfulOrders(successfulOrders);
      setFailedOrders(failedOrders);

      console.log("Successful Orders:", successfulOrders);
      console.log("Failed Orders:", failedOrders);
    } catch (error) {
      setInvoiceStatus({ message: "Curently not active oredrs", type: "error" });
      console.error("Error:", error);
    }
  };

  const handleRecreateInvoices = async () => {
    if (failedOrders.length === 0) {
      setInvoiceStatus({ message: "No failed orders to recreate.", type: "info" });
      return;
    }

    try {
      setInvoiceStatus({ message: "Recreating failed invoices...", type: "info" });
      const response = await recreateSalesInvoice();
      console.log("API Response:", response); // Debugging the response structure

      // Filter successful and failed orders
      const successfulOrders = response.filter((item) => item.status === "Success");
      const failedOrders = response.filter((item) => item.status === "Failed");

      // Determine the status message
      if (successfulOrders.length > 0 && failedOrders.length === 0) {
        setInvoiceStatus({ message: "All invoices created successfully!", type: "success" });
      } else if (successfulOrders.length > 0 && failedOrders.length > 0) {
        setInvoiceStatus({
          message: `${successfulOrders.length} invoices created successfully. ${failedOrders.length} failed.`,
          type: "warning",
        });
      } else {
        setInvoiceStatus({ message: "Failed to create invoices. Please check the details.", type: "error" });
      }

      // Store successful and failed orders for display
      setSuccessfulOrders(successfulOrders);
      setFailedOrders(failedOrders);

      console.log("Successful Orders:", successfulOrders);
      console.log("Failed Orders:", failedOrders);
    } catch (error) {
      setInvoiceStatus({ message: "An error occurred while creating invoices. Please try again.", type: "error" });
      console.error("Error:", error);
    }
  };

  // Helper function to determine status class
  const getStatusClass = (type) => {
    switch (type) {
      case "success":
        return "status-success";
      case "error":
        return "status-error";
      case "warning":
        return "status-warning";
      case "info":
        return "status-info";
      default:
        return "";
    }
  };

  return (
    <div className="container">
      <h1 className="title">ERP Orders Management</h1>

      <div className="upload-section">
        <h2>Import Amazon Orders in Database</h2>
        <input
          type="file"
          className="file-input"
          onChange={(e) => handleFileChange(e, "amazon")}
          accept=".xlsx, .xls"
        />
        <button
          onClick={() => handleUpload(uploadAmazonExcel, "amazon")}
          className="action-button"
        >
          Import Amazon Orders
        </button>
        {amazonStatus.message && (
          <p className={`status ${getStatusClass(amazonStatus.type)}`}>
            {amazonStatus.message}
          </p>
        )}
      </div>

      <div className="upload-section">
        <h2>Import Meesho Orders in Database</h2>
        <input
          type="file"
          className="file-input"
          onChange={(e) => handleFileChange(e, "meesho")}
          accept=".xlsx, .xls"
        />
        <button
          onClick={() => handleUpload(uploadMeeshoExcel, "meesho")}
          className="action-button"
        >
          Import Meesho Orders
        </button>
        {meeshoStatus.message && (
          <p className={`status ${getStatusClass(meeshoStatus.type)}`}>
            {meeshoStatus.message}
          </p>
        )}
      </div>
       <div className="upload-section">
        <h2>Import Flipkart Orders in Database</h2>
        <input
          type="file"
          className="file-input"
          onChange={(e) => handleFileChange(e, "flipkart")}
          accept=".xlsx, .xls"
        />
        <button
          onClick={() => handleUpload(uploadFlipKartExcel, "flipkart")}
          className="action-button"
        >
          Import FlipKart Orders
        </button>
        {flipkartStatus.message && (
          <p className={`status ${getStatusClass(flipkartStatus.type)}`}>
            {flipkartStatus.message}
          </p>
        )}
      </div> 

      <div className="invoice-section">
        <h2>Create Invoices in ERP</h2>
        <h2><button onClick={handleCreateInvoice} className="action-button">
          Generate Sales Invoices
        </button></h2>
        {invoiceStatus.message && (
          <p className={`status ${getStatusClass(invoiceStatus.type)}`}>
            {invoiceStatus.message}
          </p>
        )}

        {/* Display Successful Orders */}
        {successfulOrders.length > 0 && (
          <div className="successful-orders">
            <h3>Successful Orders</h3>
            <ul>
              {successfulOrders.map((order, index) => (
                <li key={index}>
                  <strong>Order ID:</strong> {order.orderId}
                  <strong></strong> {order.status}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Display Failed Orders */}
        {failedOrders.length > 0 && (
          <div className="failed-orders">
            <h3>Failed Orders</h3>
            <ul>
              {failedOrders.map((order, index) => {
                let errorMessage = "No details available";
                try {
                  const parsedDetails = JSON.parse(order.details);
                  if (parsedDetails._server_messages) {
                    const serverMessages = JSON.parse(parsedDetails._server_messages);
                    const messageObject = JSON.parse(serverMessages[0]);
                    errorMessage = messageObject.message || errorMessage;
                  }
                } catch (err) {
                  console.error("Failed to parse error details:", err);
                }
                return (
                  <li key={index}>
                    <strong>Order ID:</strong> {order.orderId}
                    <strong> Error:</strong> {errorMessage}
                  </li>
                );
              })}
            </ul>
            <button
              onClick={handleRecreateInvoices}
              className="action-button recreate-button"
            >
              Recreate Failed Invoices
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateInvoice;